import React from 'react'
import createReactClass from 'create-react-class'
import ModalWrapper from './modal-wrapper'
import ModalContent from './modal-content'

export default createReactClass({
  getInitialState () {
    return {
      name: '',
    }
  },
  handleChange (e) {
    const val = e.target.value
    this.setState({name: val})
  },

  onCreate (e) {
    e.preventDefault()
    this.props.onCreate(this.state.name)
  },

  render () {
    return (
      <ModalWrapper>
        <ModalContent title='New Portfolio' {...this.props}>
          {this.props.error ? <div className='modal-error'>{this.props.error}</div> : ''}
          <form className='refresh-token' onSubmit={this.onCreate}>
            <div className="form-field flex-display">
              <label htmlFor='portfolio-name'>Name</label>
              <input
                placeholder="name"
                name="portfolio_name"
                type="text"
                value={this.state.password}
                onChange={this.handleChange}/>
            </div>
            <div className="form-field btn-container flex-display refresh">
              <button className='btn btn-block' type='submit' disabled={!this.state.name}>Create</button>
            </div>
          </form>
        </ModalContent>
      </ModalWrapper>
    )
  },
})



// WEBPACK FOOTER //
// ./src/components/modal-panels/portfolio-modal-panel.js